<template>
    <div id="news">
        <div class="img">
            <img src="../assets/banner_new.png" alt="">
        </div>
        <div class="content">
            <div class="head_bar">
                <span>位置：</span>
                <a href="/helloworld">首页</a> >
                <span>企业新闻</span>
            </div>
            <div class="title">
                <div><span>企业新闻</span></div>
                <span>CORPORATE NEWS</span>
            </div>
            <div class="news_zi">
                <ul class="news_zi_ul">
                    <li class="clearfix">
                        <div class="news_left clearfix">
                            <div class="pic">
                                <a href="javascript:void(0)">
                                    <img src="../assets/news1.png" alt="" />
                                </a>
                                <i></i>
                            </div>
                            <div class="txt">
                                <a href="javascript:void(0)">生日会，大咖云集谈感想</a>
                                <p>这期主题是：“有人说，时间仓促，过的还没好好体验”。感想完，总结了几点：时间只能从孩子身上才能真实的体现；每次的决定都是至关重要的；所有的事情，只要你说出来，就成功一半。</p>

                            </div>
                        </div>
                        <div class="news_right">
                            <span>05.28</span>
                            <time>2018</time>
                        </div>
				    </li>
                    <li class="clearfix">
                        <div class="news_left clearfix">
                            <div class="pic">
                                <a href="javascript:void(0)">
                                    <img src="../assets/news2.png" alt="" />
                                </a>
                                <i></i>
                            </div>
                            <div class="txt">
                                <a href="javascript:void(0)">游日照，看波涛汹涌</a>
                                <p>
                                    因日光先照而得名，是一个美丽的海滨小城。沿海从南到北六十公里金沙滩，日照最主要的景点都集中于此。空气很新鲜，海鲜还挺便宜，而且感觉当地人很热情。
                                </p>
                            </div>
                        </div>
                        <div class="news_right">
                            <span>07.21</span>
                            <time>2017</time>
                        </div>
                    </li>
                    <li class="clearfix">
                        <div class="news_left clearfix">
                            <div class="pic">
                                <a href="javascript:void(0)">
                                    <img src="../assets/news3.png" alt="" />
                                </a>
                                <i></i>
                            </div>
                            <div class="txt">
                                <a href="javascript:void(0)">“我思故我在。”</a>
                                <p>做一个重要人物，我们首先必须看重自己，真正地看重自己，然后才能赢得他人的尊重。再重复一遍这个逻辑：你如何思维决定你如何行动，你如何行动，却又决定别人如何对你做出反应。</p>

                            </div>
                        </div>
                        <div class="news_right">
                            <span>09.25</span>
                            <time>2016</time>
                        </div>
                    </li>
                    <li class="clearfix">
                        <div class="news_left clearfix">
                            <div class="pic">
                                <a href="javascript:void(0)">
                                    <img src="../assets/news4.png" alt="" />
                                </a>
                                <i></i>
                            </div>
                            <div class="txt">
                                <a href="javascript:void(0)">花落流水春又去</a>
                                <p>
                                    越中山水绝纤尘，溪口风光步步新；若得会稽藏拙处， 白云深处亦行春。”范仲淹眼中最向往的山水风光，正是杭州萧山河上镇下门村的真实写照。
                                </p>
                            </div>
                        </div>
                        <div class="news_right">
                            <span>04.05</span>
                            <time>2016</time>
                        </div>
                    </li>
                    <li class="clearfix">
                        <div class="news_left clearfix">
                            <div class="pic">
                                <a href="javascript:void(0)">
                                    <img src="../assets/news5.png" alt="" />
                                </a>
                                <i></i>
                            </div>
                            <div class="txt">
                                <a href="javascript:void(0)">这是我们想去的地方</a>
                                <p>
                                    春暖花开，桃花苑天地精品大咖云集，活动丰富。不仅 有适合小朋友们的春游活动，有适合老年朋友的喝茶加棋牌， 还有书法大咖们的加盟，乃至电视真人秀节目的拍摄。 这可把桃花宝宝们忙坏了，不过没关系，累并快乐着，桃花宝宝非常欢迎大家的到来……
                                </p>
                            </div>
                        </div>
                        <div class="news_right">
                            <span>03.21</span>
                            <time>2016</time>
                        </div>
                    </li>
			    </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"news",
    data(){
        return {

        }
    }
}
</script>

<style>
@import '../assets/css/stroke.css';
</style>



// WEBPACK FOOTER //
// src/components/news.vue